// https://developer.spotify.com/documentation/web-playback-sdk/quick-start/#

export const authEndPoint = "https://accounts.spotify.com/authorize";

const clientId = "576e54ea425148cc9cbbf8ba200962ec";

const redirectUri = "https://spotify-clone-1e0e7.web.app/";

const scopes = [
  "user-read-currently-playing",
  "user-read-recently-played",
  "user-read-playback-state",
  "user-top-read",
  "user-modify-playback-state",
  "user-library-read"
];

export const getTokenFromUrl = new URLSearchParams(window.location.hash.substring(1)).get("access_token");

export const loginUrl = `${authEndPoint}?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scopes.join(
    "%20"
  )}&response_type=token&show_dialog=true`;

// %20 is ascii code for space
